import React, { useEffect } from 'react';
import qs from 'query-string';

// 简单移动端风格（可用vant、taro-ui等替换）
const WxEntry = () => {
  useEffect(() => {
    const ua = window.navigator.userAgent.toLowerCase();
    if (!ua.includes('micromessenger')) {
      window.location.href = '/';
      return;
    }
    const params = qs.parse(window.location.search);

    // 检查本地 token 是否存在且有效（可根据后端 JWT 过期策略调整）
    const token = localStorage.getItem('token');
    let tokenValid = false;
    if (token) {
      try {
        // 简单校验 JWT 过期（不依赖第三方库，生产可用 jwt-decode）
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp && payload.exp * 1000 > Date.now()) {
          tokenValid = true;
        }
      } catch (e) {}
    }
    if (tokenValid) {
      window.location.href = '/wx/home';
      return;
    }

    // --- 微信公众号自动静默授权 ---
    if (!params.code) {
      // 未带code，自动跳转微信授权页
      const appid = 'wxe77d05f087ae03d5'; // TODO: 替换为你的公众号appid
      const redirect_uri = encodeURIComponent(window.location.href);
      const scope = 'snsapi_userinfo';
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=${scope}&state=ghpt#wechat_redirect`;
      return;
    }
    // --- end ---


    // 步骤1：如未带 code，则请求后端获取 appid 并跳转授权页
    if (!params.code) {
      fetch('/api/wechat/appid')
        .then(res => res.json())
        .then(data => {
          if (!data.appid) throw new Error('无法获取微信AppID');
          const redirect_uri = encodeURIComponent(window.location.href);
          const scope = 'snsapi_userinfo';
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${data.appid}&redirect_uri=${redirect_uri}&response_type=code&scope=${scope}&state=ghpt#wechat_redirect`;
        })
        .catch(e => {
          alert('微信授权初始化失败：' + e.message);
          window.location.href = '/';
        });
      return;
    }
    // 步骤2：带 code，调用后端换 token（无感登录）
    fetch(`/api/wechat/oauth?code=${params.code}`)
      .then(res => res.json())
      .then(data => {
        console.log('【微信登录接口返回】', data);
        console.log('user:', data.user, 'openid:', data.user && data.user.openid);
        if (data.token) {
          console.log('命中 token 分支');
          localStorage.setItem('token', data.token);
          localStorage.removeItem('user');
          if (data.user) {
            localStorage.setItem('user', JSON.stringify(data.user));
          }
          // log并延迟跳转，确保token已写入
          console.log('[WxEntry] set token:', localStorage.getItem('token'));
          // 跳转回原始redirect参数指定的页面
          const redirect = params.redirect || '/';
          setTimeout(() => {
            window.location.href = redirect;
          }, 100);
        } else {
          console.log('命中失败分支', data);
          alert(data.message || '微信登录失败');
          window.location.href = '/';
        }
      })
      .catch(() => {
        alert('微信登录接口异常');
        window.location.href = '/';
      });
  }, []);

  return (
    <div style={{textAlign:'center',marginTop:'30vh',fontSize:18}}>
      <div>正在微信授权登录…</div>
    </div>
  );
};

export default WxEntry;
